(function($, Drupal) {
  Drupal.behaviors.pathway_stats = {
    attach: function(context, settings) {
      // Declare variables
      let $counters,
          $counter_blocks,
          $element_top,
          $element_bottom,
          $viewport_top,
          $viewport_bottom,
          $pause_motion,
          $duration;

      $counter_blocks = $('.block-inline-blockstats');

      // Add id to each counter block
      $counter_blocks.each(function(i) {
        $(this).attr('id', 'counter-' + i);
      });

      // Fire on scroll to start count of block as it shows up in view port
      $(window).once('scroll-page-stats').on('scroll', function() {
        // Check if reduce motion has been clicked
        // $pause_motion = $('#reduce-motion').hasClass('paused');
        $duration = 3000;

        $counter_blocks.each(function() {
          if (!$(this).hasClass('no')) {
            $element_top = $(this).offset().top + 200;
            $element_bottom = $element_top + $(this).outerHeight();
            $viewport_top = $(window).scrollTop();
            $viewport_bottom = $viewport_top + $(window).height();

            // Set duration of count animation to 0 if reduce motion has been clicked
            if ($pause_motion) {
              $duration = 0;
            }

            if ($element_bottom > $viewport_top && $element_top < $viewport_bottom) {
              $counters = $(this).find('.counter');
              $counters.once('count-stats').each(function() {
                let $counter,
                    $count_limit;

                $counter = $(this);
                $count_limit = $counter.attr('data-count');

                $({ countNum: $counter.text() }).animate(
                  {
                    countNum: $count_limit
                  },
                  {
                    duration: $duration,
                    easing: 'linear',
                    step: function() {
                      $counter.text(Math.floor(this.countNum));
                    },
                    complete: function() {
                      $counter.text(this.countNum);
                    }
                  }
                );
              });
            }
          }
        });
      });
    }
  };
})(jQuery, Drupal);
